var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 120 39",
    width: "120pt",
    height: "39pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_irmkH5A05kAunpAJejl4KwlPqxjmfy5l"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 39
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_irmkH5A05kAunpAJejl4KwlPqxjmfy5l)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_iKdHDVkzeaZLJhcE9gaPAKdmvr3CHYNd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 39,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_iKdHDVkzeaZLJhcE9gaPAKdmvr3CHYNd)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_zj45JKngm6GQgu8pfRVDS1J7XQscjlyO"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 0 0.014 L 0 38.986 L 120 38.986 L 120 0.014 L 0 0.014 Z ",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_zj45JKngm6GQgu8pfRVDS1J7XQscjlyO)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 42.275 38.426 L 48.349 0.67 L 58.063 0.67 L 51.985 38.426 L 42.275 38.426 Z ",
    fill: "rgb(6,95,162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 87.222 1.599 C 85.297 0.837 82.282 0.014 78.514 0.014 C 68.914 0.014 62.153 5.135 62.096 12.476 C 62.041 17.899 66.923 20.926 70.609 22.733 C 74.39 24.583 75.66 25.762 75.643 27.415 C 75.619 29.949 72.623 31.103 69.83 31.103 C 65.941 31.103 63.875 30.531 60.685 29.119 L 59.434 28.52 L 58.071 36.973 C 60.339 38.025 64.536 38.94 68.893 38.986 C 79.105 38.986 85.733 33.927 85.81 26.085 C 85.848 21.795 83.259 18.525 77.654 15.829 C 74.258 14.082 72.177 12.917 72.2 11.149 C 72.2 9.578 73.959 7.9 77.764 7.9 C 80.939 7.849 83.242 8.585 85.035 9.347 L 85.906 9.784 L 87.222 1.599 Z ",
    fill: "rgb(6,95,162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 100.156 25.04 C 100.959 22.866 104.026 14.488 104.026 14.488 C 103.968 14.589 104.823 12.302 105.314 10.887 L 105.971 14.141 C 105.971 14.141 107.832 23.151 108.219 25.04 L 100.156 25.04 Z  M 112.135 0.707 L 104.629 0.707 C 102.303 0.707 100.563 1.379 99.541 3.836 L 85.111 38.438 L 95.313 38.438 C 95.313 38.438 96.982 33.785 97.36 32.765 C 98.474 32.765 108.384 32.781 109.801 32.781 C 110.092 34.1 110.985 38.438 110.985 38.438 L 120 38.438 L 112.135 0.707 Z ",
    fill: "rgb(6,95,162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 34.126 0.698 L 24.614 26.445 L 23.6 21.211 C 21.83 15.18 16.313 8.645 10.145 5.371 L 18.842 38.394 L 29.121 38.38 L 44.416 0.698 L 34.126 0.698 Z ",
    fill: "rgb(6,95,162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 15.789 0.675 L 0.123 0.675 L 0 1.457 C 12.188 4.584 20.253 12.137 23.6 21.211 L 20.193 3.862 C 19.606 1.47 17.9 0.755 15.789 0.675 Z ",
    fill: "rgb(249,168,51)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.33232cf0345e836cb4247c9479dbdb55.svg";
export { ForwardRef as ReactComponent };